export default __webpack_public_path__ + "static/media/cert-student-cpttm-sc.d64cc215.jpg";